/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { observer } from 'mobx-react'
import { Radio } from 'antd'
import { Schema$MarketBlock } from '@protocol/game'
import { OUTCOME_CLASS, RADIO_GROUP_CLASS, TypeProps } from '../OutcomeBlockNew'

/**
 * 기준점이 없는 승패 또는 승무패 마켓, 아웃컴 1~3개인 마켓에 주로 사용
 * 테이블 상단 컬럼: 아웃컴 이름 (ex. 첼시, 리버풀)
 * 테이블 좌측 컬럼: 없음
 *
 * @param {TypeProps} props
 */
const Type1: React.FC<TypeProps> = (props: TypeProps) => {

  const {
    markets,
    initialOutcomeCount,
    renderOutcomeHeader,
    makeOutcomesElement,
    selectedField,
  } = props

  const viewKeyPrefix = 'OutcomeBlockType:Type1:'

  const outcomeHeadOrders = []
  for (let i = 1; i <= initialOutcomeCount; i += 1) {
    outcomeHeadOrders.push(i)
  }

  const renderOutcomes = (market: Schema$MarketBlock) => {
    const outcomes = []
    for (let i = 1; i <= initialOutcomeCount; i += 1) {
      const outcome = market.outcomes.find(object => object.order === i)
      outcomes.push(outcome)
    }

    const outcomeElements = makeOutcomesElement(market, outcomes)
    return outcomeElements
  }

  return (
    <Fragment>
      <div className={OUTCOME_CLASS.DEFAULT}>
        {renderOutcomeHeader(markets[0], outcomeHeadOrders)}
      </div>
      <div className="outcome-btn-wrap">
        <Radio.Group
          value={selectedField}
          className={initialOutcomeCount === 3 ? RADIO_GROUP_CLASS.BTN_3_WAY : RADIO_GROUP_CLASS.BTN_2_WAY}
        >
          {markets.map(market => (
            <div key={`${viewKeyPrefix}_${market.id}_${market.specialBetValue}`} className="btn-group">
              {renderOutcomes(market)}
            </div>
          ))}
        </Radio.Group>
      </div>
    </Fragment>
  )
}

export default observer(Type1)
